import fetch from '~/utils/fetch';
import { LOGIN_URL, REGISTER_URL } from '~/consts/urls';

export const loginRequest = data =>
  fetch(LOGIN_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });

export const registerRequest = data =>
  fetch(REGISTER_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
